<div class="why-screen">
  <div class="why-header">
    <mat-icon class="i-icon">info</mat-icon>
    <div>
      {{ 'why_are_you_taking_my_photo' | translate }}
    </div>
  </div>
  <img class="camera-image" src="assets/images/camera.svg" alt="camera" />
  <div class="why-body" [innerHTML]="'why_face_id_body' | translate"></div>
  <button mat-raised-button mat-dialog-close class="okay">{{ 'okay' | translate }}</button>
</div>
